import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { globalStore } from '../../../../shared/shared.global-service';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectCurrentServiceId, selectFolderId } from '../../../store/person/person.selectors';
import { FolderRiskStatusObject } from '@libs/types/src/services/object-type/folder/folder-risk-status.object';

@Injectable()
export class PersonRisksStore extends ComponentStoreV2Factory {
    folderId = toSignal(globalStore!.select(selectFolderId));
    items = computed<FolderRiskStatusObject[]>(() => this.data.getFolderRiskStatuses()?.items || []);
    serviceId = toSignal(globalStore!.select(selectCurrentServiceId));

    riskTypes = computed<string[]>(() => {
        const item = this.data.getServiceSettings()?.items[0];
        return item?.data && JSON.parse(item.data).riskTypes || [];
    });
}
